module.exports = __webpack_public_path__ + "assets/feelsLike.ad476fbd.svg";